<template>
<div class="chapter">
<div class="inner_page">
<p><a id="tp"></a></p>
<div class="centerAligned"><img alt="001" class="imgepub" src="henn_9781595585820_oeb_001_r1.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595585820_oeb_tp_r1.vue?1ac9fcbc